import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useCdnImg } from '@webplatform/cdn-image';

interface Props {
  title: string;
  description: string;
  images: Array<string>;
  link: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MainFromCanionMainBlockLarge',
  props: {
    title: null,
    description: null,
    images: null,
    link: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  description: string;
  images: Array<string>;
  link: string;
};



const { generateUrl } = useCdnImg();

const images = computed(() => {
  return props.images.map((image) =>
    image ? generateUrl(image, { width: 1024 }) : '/img/placeholder.png',
  );
});

return { __sfc: true,props, generateUrl, images }
}

})